import React from 'react';
import ResourceLibrary from '../resources/ResourceLibrary';

const MenteeResources: React.FC = () => (
  <ResourceLibrary
    eyebrow="Mentee"
    lead="Todo el material del programa en un solo lugar: guías, videos y plantillas de autoevaluación que puedes revisar antes de cada sesión y volver a consultar cuando lo necesites."
  />
);

export default MenteeResources;
